import getStorageInstance from './getSuperStoreInstance';
export let SUPERSTORE_NAMESPACES;
(function (SUPERSTORE_NAMESPACES) {
  SUPERSTORE_NAMESPACES["NOTIFICATION"] = "NOTIFICATIONS";
})(SUPERSTORE_NAMESPACES || (SUPERSTORE_NAMESPACES = {}));
export let SUPERSTORE_STORAGE_KEYS;
(function (SUPERSTORE_STORAGE_KEYS) {
  SUPERSTORE_STORAGE_KEYS["PERSISTENT"] = "persistent";
  SUPERSTORE_STORAGE_KEYS["BROWSER"] = "browser";
  SUPERSTORE_STORAGE_KEYS["SIDEBAR_NOTIFICATION_TYPES"] = "SIDEBAR_NOTIFICATION_TYPES";
})(SUPERSTORE_STORAGE_KEYS || (SUPERSTORE_STORAGE_KEYS = {}));
export let SUPERSTORE_STORAGE_ITEMS;
(function (SUPERSTORE_STORAGE_ITEMS) {
  SUPERSTORE_STORAGE_ITEMS["HAS_BANNER_NOTIFICATIONS"] = "HAS_BANNER_NOTIFICATIONS";
  SUPERSTORE_STORAGE_ITEMS["LAST_CHECKED"] = "LAST_CHECKED";
  SUPERSTORE_STORAGE_ITEMS["LAST_PUSH_SUBSCRIBE_TIME"] = "LAST_PUSH_SUBSCRIBE_TIME";
  SUPERSTORE_STORAGE_ITEMS["PRESENCE_PING_TOKEN"] = "PRESENCE_PING_TOKEN";
  SUPERSTORE_STORAGE_ITEMS["TYPES"] = "TYPES";
})(SUPERSTORE_STORAGE_ITEMS || (SUPERSTORE_STORAGE_ITEMS = {}));
export const setStorageJsonValue = async ({
  namespace,
  storageKey,
  storageItem,
  value,
  usePartition
}) => {
  try {
    const store = await getStorageInstance(namespace, usePartition);
    const json = (await store.get(storageKey)) || {};
    if (value !== undefined) {
      json[storageItem] = value;
    } else {
      if (storageItem in json) {
        delete json[storageItem];
      } else {
        // No need to set again if property wasn't there to be deleted
        return true;
      }
    }
    await store.set(storageKey, json);
    return true;
  } catch (error) {
    return false;
  }
};
export const getStorageJsonValue = async ({
  namespace,
  storageKey,
  storageItem,
  usePartition
}) => {
  try {
    const store = await getStorageInstance(namespace, usePartition);
    const json = await store.get(storageKey);
    if (json && storageItem in json) {
      return json[storageItem];
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};